import { Directive, ElementRef, Input } from '@angular/core';

import { BoundActionFn } from 'src/app/table-handling';

@Directive({
  selector: '[appAction]',
  standalone: true,
})
export class ActionDirective {
  public static readonly ACTION_CLASS = 'sd-interactive';

  @Input() public value: unknown;
  @Input() public set appAction(action: BoundActionFn | null) {
    this.updateAction(action);
  }

  private action: BoundActionFn | null;

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  protected handleClick = (): void => {
    this.action?.(this.value);
  };

  private updateAction(action: BoundActionFn | null): void {
    if (this.action === action) {
      return;
    }

    this.action = action;

    const element = this.element.nativeElement;

    if (this.action) {
      element.classList.add(ActionDirective.ACTION_CLASS);
      element.addEventListener('click', this.handleClick);
    } else {
      element.classList.remove(ActionDirective.ACTION_CLASS);
      element.removeEventListener('click', this.handleClick);
    }
  }
}

